import React from 'react';
import { Link } from 'react-router-dom';

const AuthLayout = ({ title, subtitle, children }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 px-4 py-8">
      <div className="w-full max-w-md bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl border border-gray-200/60 p-8">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-extrabold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">{title}</h1>
          {subtitle && <p className="text-gray-600 mt-2 text-sm font-medium">{subtitle}</p>}
        </div>
        {children}
        <div className="mt-8 text-center text-xs text-gray-500">
          <p>Secured by Supabase Auth</p>
          <p className="mt-1">&copy; {new Date().getFullYear()} Naming Tool</p>
        </div>
        <div className="mt-4 text-center text-sm">
          <Link to="/file-naming" className="text-blue-600 hover:underline font-medium">Back to App</Link>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;